import React from "react";
import cookieUtil from "../utils/cookieUtil";
import {GetAccountInfo, jumpLogin} from "../utils/common";
import {PlatMd5} from "../utils/platMd5";
import {useIonViewWillEnter} from "@ionic/react";
import {AuthUserInfo, getTokenParam} from "../pages/member/Service";
const {getQueryVariable} = require("../utils/commonFunction");
const {base64Des} = require("../utils/commonSecret");

interface FooterProps {
    title: string,
    isJumpLogin: boolean,
}

const MFooter: React.FC<FooterProps> = ({title, isJumpLogin}) => {

    useIonViewWillEnter(() => {
        //console.log(cookieUtil.has("access_token"));
        let pmsMd5 = getQueryVariable(PlatMd5.hashStr('pms').toUpperCase());
        let pms = getQueryVariable('pm');
        if (pmsMd5 != null) { //原账号查看等微信传值
            let token = base64Des(pmsMd5)
            cookieUtil.put("access_token", token);
            flushUrl(pmsMd5);
        } else if (pmsMd5 == null && pms != null) { //内嵌页跳转
            getTokenParams(pms, isJumpLogin);
        } else if (!cookieUtil.has("access_token") && isJumpLogin) {
            jumpLogin(window.location.href);
        } else if(cookieUtil.has("access_token") && !cookieUtil.has("userInfo")){
            GetAccountInfo(isGetInfo, isJumpLogin).then();
        }
    })

    function getTokenParams(pms: string, isLogin: boolean) {
        let params = {
            pagePm: pms
        }
        getTokenParam(params, '?pagePm=' + pms).then(ret => {
            if (ret.code === '10000') {
                localStorage.setItem("appBaseInfo", JSON.stringify(ret.data));
                cookieUtil.put("access_token", ret.data.accessToken);
                GetAccountInfo(isGetInfo, isLogin).then();
            }
        })
    }

    function isGetInfo(ret: any, isLogin: boolean) {
        let url = window.location.href;
        let pm = getQueryVariable('pm');
        url = url.indexOf(pm) > 0 && pm != null ? url.replace('pm=' + pm, 't=1') : url;
        if (ret.code === '10000') {
            window.location.href = url;
            cookieUtil.put("userInfo", JSON.stringify(ret.data));
        } else {
            cookieUtil.remove("access_token");
            cookieUtil.remove("userInfo");
            if (isLogin) {
                jumpLogin(url);
            } else {
                window.location.href = url;
            }
        }
    }

    function flushUrl(pmsMd5: string) {
        let url = window.location.href;
        url = url.replace(PlatMd5.hashStr('pms').toUpperCase() + '=' + pmsMd5, 't=2');
        window.location.href = url;
    }

    return (
        <div>
            <div className="p-foot">
                <p>91y游戏中心 版权所有</p>
                <p>ICP证：浙B2-20130209 <a href="http://beian.miit.gov.cn">浙ICP备13022161号-1</a></p>
                <p>杭州浮云网络科技有限公司</p>
                <p>本网络游戏适合年满18周岁（含）以上用户使用</p>
                <p><a href="https://jbts.mct.gov.cn/">全国文旅举报</a>
                    <a href="https://www.12377.cn/">12377举报</a>
                </p>
                <p>
                    <img alt="" src={require("../pages/images/m91y/1576721177854.png")}
                         style={{width: "20px", height: "20px"}}/>
                    <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010302003273">
                        浙公网安备 33010302003273号
                    </a>
                </p>
            </div>
            <div className="bottom-nav">
                <a href="https://m.91y.com"><em className="index"></em><span>首页</span></a>
                <a href="https://m.91y.com/download/"><em className="download"></em><span>下载</span></a>
                <a href="https://m.91y.com/recharge/"><em
                    className={title === "充值" ? "topup on" : "topup"}></em><span>充值</span></a>
                <a href="https://m.91y.com/news/"><em className="news"></em><span>新闻</span></a>
                <a href="https://m.91y.com/help/"><em className="help"></em><span>帮助</span></a>
            </div>

            <a href="https://business.91y.com/kefu"
               className="right-service">
                <span className="txt">客服</span>
            </a>
        </div>
    );
};

export default MFooter;
